/* unplugin-vue-components disabled */
import {Rest} from 'utils'
import {stringToFile} from 'utils/utils'
import {API2_INGEST} from 'consts/api2'


export default {
  data() {
    return {
      rest: new Rest(),
      loading: false,
      data: {}
    }
  },
  computed: {
    ingest_cert() {
      return this.data.cert
    },
    ingest_valid_to() {
      return new Date(this.data.valid_to).toLocaleString()
    },
    ingest_privkey() {
      return this.data.privkey
    },
    ingest_pubkey() {
      return this.data.pubkey
    },
    ingest_pass() {
      return this.data.pass
    },
    role_arn() {
      return this.data.role_arn
    },
    ta_arn() {
      return this.data.trust_anchor_arn
    },
    profile_arn() {
      return this.data.profile_arn
    },
    bucket_name() {
      return this.data.bucket_name
    },
    have_certs() {
      return this.ingest_cert && this.ingest_privkey && this.ingest_pass && this.ingest_pubkey && this.bucket_name
    },
  },
  async mounted() {
    this.loading = true
    this.data = await this.rest.get(`${API2_INGEST}/info`)
    this.loading = false
  },
  methods: {
    async onCreate() {
      this.loading = true
      const credentials = await this.rest.post(`${API2_INGEST}/recreate`)
      this.data = {...this.data, ...credentials}
      this.loading = false
      $utils.toasts.success('Ingest credentials recreated successfully', 5000)
    },
    stringToFile(data, fname) {
      return stringToFile(data, fname)
    }
  }
}
